module.exports = __webpack_public_path__ + "img/allowances.f24cdb5b.svg";